<div class="error-message" *ngIf="this.message != ''">
    <p class="note">{{this.message}}</p>
</div>
